<template>
  <me-combo-tree v-bind="$props" v-on="$listeners" :data="comboData" />
</template>
<script>

import http from '@common/ExtendHttp'
import comboMixin from '../mixins/combo.mixin'
export default {
  mixins: [ comboMixin ],
  name: 'ComboTreeRight',
  props: {
    pathName: {
      type: String, default: '/member/right/tree'
    }
  },
  data () {
    return {
      comboData: [],
      eventName: 'refresh--comno-tree-right'
    }
  },
  created () {
    this.$eventMonitor.register(this.eventName, data => {
      http.get(this.pathName).then(data => {
        this.comboData = data || [ ]
      })
    })
    this.$eventMonitor.dispatch(this.eventName)
  }
}
</script>
